import { akeronService } from "./akeronService";

const section = "CompanyType";

function filter(name = " ", from = "0", limit = "10", active = "1") {
  return akeronService.make_get_request(`${section}/ListCompanyType/${name}/${from}/${limit}/${active}`, {}).then((response) => {
    let result = {
      quantity: response.quantity || 0,
      list: response.companyTypes || response.list || [],
    };
    return result;
  });
}

function getAll() {
  return akeronService.make_get_request(`${section}`, {}).then((response) => {
    // Si response ya es un array, usarlo directamente
    return Array.isArray(response) ? response : (response.companyTypes || response.list || []);
  });
}

function remove(id) {
  return akeronService.make_delete_request(`${section}/${id}`, {});
}

function create(item) {
  const param = {
    name: item.name,
  };
  return akeronService.make_post_request(`${section}`, param);
}

function update(item) {
  const param = {
    id: item.id,
    name: item.name,
    isActive: item.isActive !== undefined ? item.isActive : true,
  };
  return akeronService.make_put_request(`${section}/${item.id}`, param);
}

export const companyTypeService = {
  getAll,
  filter,
  remove,
  create,
  update,
};
